module.exports = __webpack_public_path__ + "img/fullscreen.efc5c9b2.svg";